import React from 'react';
import ContactButton from './ContactButton';

// Configuración de perfiles IT - fácil de modificar
const IT_PROFILES = [
  {
    id: 1,
    title: "Desarrolladores full stack",
    icon: "/profiles/icon_full_stack.svg"
  },
  {
    id: 2,
    title: "Expertos en inteligencia artificial",
    icon: "/profiles/icon_ia.svg"
  },
  {
    id: 3,
    title: "Arquitectos de Software",
    icon: "/profiles/icon_architecture.svg"
  },
  {
    id: 4,
    title: "UX/ UI Designer",
    icon: "/profiles/icon_ux_ui.svg"
  },
  {
    id: 5,
    title: "Líderes técnicos",
    icon: "/profiles/icon_lideres_tecnicos.svg"
  },
  {
    id: 6,
    title: "QA manual y automatizado",
    icon: "/profiles/icon_qa.svg"
  },
  {
    id: 7,
    title: "Product owner y Scrum master",
    icon: "/profiles/icon_product_owner.svg"
  }
];

const ITProfilesSection: React.FC = () => {
  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          {/* Profile Images */}
          <div className="flex justify-center mb-8">
            <img 
              src="/profiles.png" 
              alt="Perfiles de equipo" 
              className="h-16 w-auto"
            />
          </div>
          
          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Perfiles TI disponibles
          </h2>
          
          {/* Subtitle */}
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Todos los perfiles pasan por validación técnica antes de integrarse tu equipo.
          </p>
        </div>

        {/* Profiles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {IT_PROFILES.map((profile) => (
            <div 
              key={profile.id}
              className="flex items-center space-x-4 p-4 rounded-lg shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex-shrink-0">
                <img 
                  src={profile.icon} 
                  alt={profile.title}
                  className="h-6 w-6 text-gray-700"
                />
              </div>
              <span className="text-gray-900 font-medium">
                {profile.title}
              </span>
            </div>
          ))}
        </div>

        {/* Infrastructure Specialization Section */}
        <div className="relative overflow-hidden rounded-3xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer">
          {/* Dots background as image to avoid build resolver issues */}
          <img
            src="/bg_card_infraestructura.png"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover"
          />

          <div className="relative z-10 p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Content (left) */}
              <div>
                {/* Badge */}
                <div className="mb-6">
                  <div className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm shadow-sm bg-white">
                    <img src="/icons/astro.svg" alt="Especialización" className="h-4 w-4" />
                    Especialización
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-8">
                  Administración de
                  <br className="hidden sm:block" />
                  Infraestructura
                </h3>

                {/* CTA Button */}
                <div>
                  <ContactButton />
                </div>
              </div>

              {/* Description (right) */}
              <div className="text-white/85 text-base md:text-lg leading-relaxed">
                Ofrecemos servicios especializados de administración de infraestructura tecnológica, garantizando seguridad, escalabilidad y continuidad operativa para tu negocio. Somos proveedores de Amazon Web Services (AWS), lo que nos permite implementar soluciones en la nube de clase mundial, optimizadas a las necesidades de tu organización.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITProfilesSection;
